import { render, staticRenderFns } from "./DdDetailDialog.vue?vue&type=template&id=33ac3ece&scoped=true"
import script from "./DdDetailDialog.vue?vue&type=script&lang=js"
export * from "./DdDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DdDetailDialog.vue?vue&type=style&index=0&id=33ac3ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac3ece",
  null
  
)

export default component.exports